module.exports = __webpack_public_path__ + "img/0-51.a04608a5.jpg";